import styled from 'styled-components';

interface CircleProps {
	backgroundColor?: string;
}

export const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const Circle = styled.div<CircleProps>`
	width: 10px;
	height: 10px;
	margin: 0;
	padding: 0;
	background-color: ${({ backgroundColor }) => backgroundColor};
	border-radius: 50%;
`;

export const Text = styled.p``;
